window.initTips = function (context) {
  $(context).find('[data-tooltip]').powerTip({
    smartPlacement: true,
    mouseOnToPopup: true
  });
};

$(function () { window.initTips(document); });



// WEBPACK FOOTER //
// ./javascripts/components/legacy/init/powertip.js